'use client';

import { useCallback, useState } from 'react';
import { useWizardContext } from '../../hooks/useWizardContext';
import { useWizardNavigation } from '../../hooks/useWizardNavigation';
import { CheckboxGroup } from '../shared/CheckboxGroup';
import { StepLayout } from '../shared/StepLayout';

const REASON_OPTIONS = [
  {
    value: '24/7 access to concierge immediate care',
    label: '24/7 access to concierge immediate care',
  },
  {
    value: 'Avoiding ER or urgent care visits',
    label: 'Avoiding ER or urgent care visits',
  },
  {
    value: 'Imaging (X-ray, ultrasound, MRI, CT)',
    label: 'Imaging (X-ray, ultrasound, MRI, CT)',
  },
  {
    value: 'Expedited access to top specialists and hospitals',
    label: 'Expedited access to top specialists and hospitals',
  },
  {
    value: 'Support managing an ongoing health condition',
    label: 'Support managing an ongoing health condition',
  },
  {
    value: 'Medical peace of mind',
    label: 'Medical peace of mind',
  },

  { value: 'Other', label: 'Other' },
];

/**
 * Reasons step - collects the user's motivations for joining Sollis Health.
 */
export function ReasonsStep() {
  const { state, dispatch } = useWizardContext();
  const { goToNextStep, goToPreviousStep, hasPreviousStep } =
    useWizardNavigation();
  const [error, setError] = useState<string | undefined>();

  // Read directly from wizard state
  const reasons = state.formData?.reasons || [];

  const handleChange = useCallback(
    (values: string[]) => {
      dispatch({
        type: 'SET_FORM_DATA',
        payload: { reasons: values },
      });
      setError(undefined);
    },
    [dispatch]
  );

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();

      if (reasons.length === 0) {
        setError('Please select at least one option');
        return;
      }

      goToNextStep();
    },
    [reasons.length, goToNextStep]
  );

  return (
    <StepLayout
      heading='What brings you to Sollis today?'
      description='Select all that apply.'
      onSubmit={handleSubmit}
      onBack={goToPreviousStep}
      showBack={hasPreviousStep}
    >
      <CheckboxGroup
        name='reasons'
        options={REASON_OPTIONS}
        values={reasons}
        onChange={handleChange}
        error={error}
      />
    </StepLayout>
  );
}
